import {
  Box,
  Card,
  CardContent,
  CardHeader,
  DialogActions,
  DialogContent,
  DialogTitle,
  Skeleton,
  Stack,
} from '@cmg/design-system';
import React from 'react';

export const LinkOrganizationModalSkeleton: React.FC = () => {
  return (
    <Box role="progressbar">
      <DialogTitle>
        <Skeleton width={240} />
      </DialogTitle>

      <DialogContent dividers>
        <Stack gap={2}>
          <Skeleton width="80%" />
          <Skeleton width="55%" />

          <Stack direction={{ xs: 'column', md: 'row' }} spacing={2}>
            <Card variant="outlined" sx={{ flex: 1 }}>
              <CardHeader title={<Skeleton width={140} />} />
              <CardContent>
                <Skeleton height={28} width="60%" sx={{ mb: 1 }} />
                <Skeleton height={28} width="60%" />
              </CardContent>
            </Card>

            <Card variant="outlined" sx={{ flex: 1 }}>
              <CardHeader title={<Skeleton width={120} />} />
              <CardContent>
                <Skeleton height={28} width="60%" sx={{ mb: 1 }} />
                <Skeleton height={28} width="60%" />
              </CardContent>
            </Card>
          </Stack>
        </Stack>
      </DialogContent>

      <DialogActions sx={{ px: 3, py: 2 }}>
        <Stack direction="row" spacing={1}>
          <Skeleton variant="rounded" width={80} height={36} />
          <Skeleton variant="rounded" width={96} height={36} />
        </Stack>
      </DialogActions>
    </Box>
  );
};
